import { react2angular } from 'react2angular';
import AgentChatLink from './AgentChatLink';

angular
  .module('bb.util')
  .component(
    'agentChatLink',
    react2angular(AgentChatLink, [
      'openContactDrawer',
      'startConvo',
      'agentId',
      'firstName',
      'lastName',
    ]),
  );
